import React, {} from 'react'
import {PALETTE} from '../../styles/paletteV3'

// inline styles so oy-vey doesn't barf when making emails using draft-js cards
const style = {
  color: PALETTE.SLATE_700,
  fontWeight: 600
}






const Hashtag = (props) => {
  const {offsetkey, children} = props
  return (
    React.createElement('span', { 'data-offset-key': offsetkey, style: style,}
      , children
    )
  )
}

export default Hashtag
